import { REGION_INDICATOR_OVERLAP, SVG_STYLES } from "../settings.ts";

export function getPanelHeight(groupsSize: number, groupHeight: number) {
  // add top/bottom strokeWidth of visible region indicator
  return groupsSize * groupHeight + SVG_STYLES.group.strokeWidth + REGION_INDICATOR_OVERLAP;
}

export function getScale(panelWidth: number, maxWidth: number) {
  return Math.min(1, (panelWidth - SVG_STYLES.group.strokeWidth) / maxWidth);
}
